import Link from 'next/link';
import React from 'react';

import { CustomLinkProps } from 'common-nextjs';

interface Props extends CustomLinkProps {}

const EventsLink: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  ...props
}) => (
  <Link prefetch={false} {...props} href="/events">
    {children}
  </Link>
);

export default EventsLink;
